"use client"

import { CaseLower } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CaseLowerIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CaseLowerIcon = component(Icon)({ as: CaseLower })
